import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { MisCompras } from './mis-compras';
import { ListadoOrdenesCompras } from './listado-ordenes-compras';



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  export default function TabCompras() {
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Cesta de compras" {...a11yProps(0)} />
            <Tab label="Ordenes de compras" {...a11yProps(1)} />
            
        
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <MisCompras />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ListadoOrdenesCompras />
        </CustomTabPanel>
      
      </Box>
    );
  }